// The outside REST API (/api/v1/public) from the dashboard side: own bearer
// keys and the PWAs provisioned with them. A key itself is returned once, on
// creation; afterwards only its prefix is visible. A super admin sees
// everyone's keys and provisions, anyone else their own.
import { api } from './client';

export interface PublicApiKey {
  id: string;
  name: string;
  key_prefix: string;
  enabled: number;
  created_by: string | null;
  owner_name: string | null;
  owner_email: string | null;
  created_at: string;
  last_used_at: string | null;
  use_count: number;
}

export interface PwaProvisionRow {
  id: string;
  kind: 'tracker' | 'plain';
  project_id: string;
  project_name: string | null;
  geo: string;
  platform: 'android' | 'ios';
  offer_id: string | null;
  offer_partner: string | null;
  pwa_id: string;
  campaign_id: string | null;
  url: string;
  language_code: string | null;
  api_key_id: string | null;
  api_key_name: string | null;
  admin_id: string | null;
  owner_name: string | null;
  owner_email: string | null;
  created_at: string;
}

export async function listPublicApiKeys(): Promise<PublicApiKey[]> {
  return api.get<PublicApiKey[]>('/admin/public-api/keys');
}

export async function createPublicApiKey(name: string): Promise<PublicApiKey & { key: string }> {
  return api.post<PublicApiKey & { key: string }>('/admin/public-api/keys', { name });
}

export async function updatePublicApiKey(id: string, patch: { enabled?: boolean; name?: string }): Promise<PublicApiKey> {
  return api.patch<PublicApiKey>(`/admin/public-api/keys/${id}`, patch);
}

export async function deletePublicApiKey(id: string): Promise<{ deleted: true }> {
  return api.delete<{ deleted: true }>(`/admin/public-api/keys/${id}`);
}

export async function listPwaProvisions(limit = 200): Promise<PwaProvisionRow[]> {
  return api.get<PwaProvisionRow[]>(`/admin/public-api/provisions?limit=${limit}`);
}
